import { createAppWrap } from '../../../create_app_wrap';
import guideList from './_guidelist_component';

const GUIDE_SELF = [
    {
        key: 'payment',
        required: true,
        title: 'お支払い方法・配送方法の設定'
    },
    {
        key: 'delivery-group',
        required: true,
        title: '配送グループの設定'
    },
    {
        key: 'alert',
        required: true,
        title: 'アラート・通知の設定'
    },
    {
        key: 'store-info',
        required: true,
        title: 'ストア情報の設定'
    },
    {
        key: 'company-info',
        required: true,
        title: '会社情報の設定'
    },
    {
        key: 'shopping-guide',
        required: true,
        title: 'お買い物ガイドの設定'
    },
    {
        key: 'policy',
        required: true,
        title: 'プライバシーポリシーの設定'
    },
    {
        key: 'item',
        required: true,
        title: '商品登録・ストアトップの作成'
    },
    {
        key: 'storematch',
        required: true,
        title: 'ストアマッチ広告への申し込み'
    },
    {
        key: 'testorder',
        required: false,
        title: 'テスト注文をする'
    }
];

const GUIDE_TOOL = [
    {
        key: 'tool_entry',
        required: true,
        title: 'magnetの無料トライアルに申し込む'
    },
    {
        key: 'tool_opensetting',
        required: true,
        title: 'オープン準備の設定をする'
    },
    {
        key: 'tool_item',
        required: true,
        title: '商品を登録する'
    },
    {
        key: 'tool_build_store',
        required: false,
        title: 'ストアトップをつくる'
    },
    {
        key: 'storematch',
        required: true,
        title: 'ストアマッチ広告への申し込み'
    },
    {
        key: 'testorder',
        required: false,
        title: 'テスト注文をする'
    }
];

const GUIDE_PARTNER = [
    {
        key: 'partner_select',
        required: true,
        title: 'Yahoo!コマースパートナーで業者選定を行う'
    },
];

const view = '[data-view="official-lp-openstep"]';
const init = () => {
    /**
     * Vueオブジェクト
     * @type {Vue|any}
     */
    createAppWrap({
        el: view,
        /**
         * データ群
         */
        data() {
            return {
                // マニュアル一覧
                guide_self: GUIDE_SELF,
                guide_tool: GUIDE_TOOL,
                guide_partner: GUIDE_PARTNER,
                // 今開いてるマニュアル
                manual: {
                    key: '',
                    required: '',
                    title: ''
                },
                // 回答(yes/noが入る)
                answer: {
                    beginner: '',
                    time: '',
                    cost: ''
                }
            };
        },
        props: {
        },
        created: function() {},
        /**
         * ミックスインオブジェクト
         */
        mixins: [],
        /**
         * コンポーネント
         */
        components: {
            // マニュアルの一覧を出力するコンポーネント
            'guide-list': guideList,
        },
        watch: {
            'answer.beginner': function() {
                this.pushGtmEvent('beginner');
            },
            'answer.time': function() {
                this.pushGtmEvent('time');
            },
            'answer.cost': function() {
                this.pushGtmEvent('cost');
            }
        },
        /**
         * 算出プロパティ
         */
        computed: {
            // 診断結果をセット
            setAnswer: function() {
                // 最後まで回答されてないならセットしない
                if (!this.answer.cost) {
                    return;
                }
                // 回答内容に応じて結果を出し分け
                if (this.answer.time==='no' && this.answer.cost==='no') {
                    return 'self';
                } else if (this.answer.time==='yes' && this.answer.cost==='no') {
                    return 'tool';
                } else {
                    return 'partner';
                }
            }
        },
        /**
         * 各種メソッド
         */
        methods: {
            // すべての診断結果を開く
            collapse_all: function() {
                return this.setAnswer = 'all';
            },
            // モーダルに各マニュアルの内容をセットする
            setModalManual: function(value) {
                this.manual = value;
            },
            // GTMにイベントを送信する
            pushGtmEvent: function(diagnose) {
                dataLayer.push({
                    'Event': 'appEvent',
                    'diagnose': diagnose,
                    'clickValue': this.answer[diagnose],
                });
            }
        },
    });
};

if (document.querySelector(view)) {
    init();
}

